import { render } from "./ArticleIndex.vue?vue&type=template&id=f27d4158&scoped=true"
import script from "./ArticleIndex.vue?vue&type=script&lang=js"
export * from "./ArticleIndex.vue?vue&type=script&lang=js"

import "./ArticleIndex.vue?vue&type=style&index=0&id=f27d4158&scoped=true&lang=css"

import exportComponent from "../../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27d4158"]])

export default __exports__